import React,{useState} from 'react';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Dialog from './Dialog';
import isArray from "lodash/isArray";
import ArrowBack from '@mui/icons-material/KeyboardArrowLeft';

import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Swipeable from './Swipeable';


class ObjectPicker extends React.PureComponent{
  constructor(props){
    super(props);
    this.state={
      //formOpen:false,
      InputBase:null,
      code:""
    }
    this.open = this.open.bind(this);
    this.search = this.search.bind(this);
    this.pick = this.pick.bind(this);
    this.close = this.close.bind(this);
    this.choose = this.choose.bind(this);
    //this.onhashchange = this.onhashchange.bind(this);
  }
  /*onhashchange(){
    if(this.current_hash!=window.location.hash &&  this.state.formOpen){
      this.setState({formOpen:false});
    }
  }*/
  async componentDidMount(){
    //window.addEventListener("hashchange",this.onhashchange);
    //
    const {default:InputBase} = await import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "InputBase" */
      "./InputBase"
    );
    this.setState({InputBase});
  }
  /*componentWillUnmount(){
    window.removeEventListener("hashchange",this.onhashchange);
  }*/
  async open(code,title,callback=null,condition=null,onClose=null,defaultData=null,props={}){
    //console.log("new hash",window.location.hash);
    //this.current_hash = window.location.hash;
    //
    this.callback = callback;
    this.onClose = onClose;
    this.cust_props = {...props,isPicker:true};
    //console.log("cust_props",  this.cust_props)
    //
    
    if(window!==undefined && window.innerWidth<480){

      /*if(this.cust_props.pickItem!=false){
        this.cust_props.hideActionsBar = true;
      }*/

        this.cust_props.hideActionsBar = true;
      //this.cust_props.hideItemActions = true;

      //this.cust_props.hideTitle = true;
      this.cust_props.mediaQueryMatches = true;
    }
    //
    this.multiSel = this.cust_props.multiSel||false;
    this.pickItem = this.cust_props.pickItem;
    this.idApp =  this.cust_props.idApp;
    


    condition = condition || this.cust_props.requiredCondition;
    defaultData = defaultData || this.cust_props.defaultData,

    this.setState({
      //formOpen:true,
      code,
      condition,
      defaultData,
      title
    },()=>{
      if(this.refDialog){
        this.refDialog.open();
      }
    })
  }
  pick(row){
    if(this.multiSel) {
      let c_row = this._list.state.rows.find(r=>r._id===row._id);
      if(c_row){
        c_row.sel = !c_row.sel;
        this._list.reRender();
      }
      return;
    }
    const self = this;
    if(this.callback && !this.multiSel && this.cust_props.pickItem!=false){
      if(this.refDialog){
        this.refDialog.close(()=>{
          self.callback(row);
          if(self.onClose){
            self.onClose();
          }
        })
      }
    }
  }
  choose(){
    if((this.cust_props.required || this.props.required) && this.multiSel &&  this._list.state.rows.filter(r=>r.sel).length==0) return;
    //this.close();
    const self = this;
    if(this.refDialog){
      this.refDialog.close(()=>{
        if(self.onClose){
          if(self.multiSel){
            const rows_selected = self._list.state.rows.filter(r=>r.sel);
            self.onClose(rows_selected);
          }else{
            self.onClose();
          }
        }
        if(self.callback && self.multiSel){
          const rows_selected = self._list.state.rows.filter(r=>r.sel);
          self.callback(rows_selected);
        }
      });
    }
  }
  close(){
    const self = this;
    if(this.refDialog){
      this.refDialog.close(()=>{
        if(self.pickItem==false && self.onClose){
          self.onClose();
        }
      });
    }
  }
  search(key){
    this._list.search(key);
  }
  render(){
    //if(!this.state.formOpen) return null;
    if(!this.state.code) return null;
    
    const {title} = this.state;
    //console.log("open object picker",this.state.formOpen);
    let required = this.cust_props.required || this.props.required;
    let showDialogTitle = this.cust_props.hideTitle || this.cust_props.hideHeader;

    let close = this.close;
    let extraButtons =[];
    if(this.cust_props.mediaQueryMatches){
      if(!required && !showDialogTitle){
        extraButtons.push(<Button  variant="outlined"  key={"btnclose"}  style={{marginRight:5}}   onClick={()=>close()}>{this.cust_props.closeLabel|| <ArrowBack/>}</Button>)
      }
      if(this.multiSel){
        extraButtons.push(<Button variant="outlined" color="primary" key={"btnchoose"} style={{marginRight:5}} onClick={()=>this.choose()}>{this.cust_props.chooseLabel||"Chọn"}</Button>);
      }
    }else{
      if(this.multiSel){
        extraButtons.push(<Button variant="outlined" color="primary" key={"btnchoose"} onClick={()=>this.choose()}>{this.cust_props.chooseLabel||"Chọn"}</Button>);
      }
      if(!required && !showDialogTitle){
        extraButtons.push(<Button  variant="outlined"  key={"btnclose"} style={{marginLeft:5}} onClick={()=>close()}>{this.cust_props.closeLabel|| "Huỷ"}</Button>)
      }
    }
    

    let fullScreen = window.innerWidth<500 || this.cust_props.fullScreen || this.props.fullScreen;
    let height = this.cust_props.height;
    let maxHeight = fullScreen?undefined:"80vh";
    let maxHeightContent = fullScreen?undefined:"60vh";
    let fullWidth =this.cust_props.mediaQueryMatches?true:(this.cust_props.fullWidth || this.props.fullWidth);

    let maxWidth = this.cust_props.formSize ||  this.props.formSize||'lg';
    if(this.cust_props.mediaQueryMatches && window.innerWidth>500){
      maxWidth ="sm";
    }

    return (
      <Dialog
        ref={ref=>this.refDialog = ref}
        fullScreen={fullScreen}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        //open={this.state.formOpen}
        onClose={close}
        disableEscapeKeyDown={required || this.cust_props.disableEscapeKeyDown || this.props.disableEscapeKeyDown}
        slotProps={{
            paper:{
              style: {
                height
              }
            }
        }}
        renderTitle={()=><>
          {showDialogTitle &&
            <DialogTitle
              sx={{
                p:2,
                pt: fullScreen ? 'max(12px, env(safe-area-inset-top))' : undefined,
              }}
            >
              <div style={{display:"flex",flexDirection:"row",alignItems:"center"}}>
                <Typography variant="h5" style={{flex:1}}>{title}</Typography>
                {!required && <IconButton key={"btnclose"} onClick={()=>close()} size="large">
                    <CloseIcon/>
                </IconButton>}
              </div>
            </DialogTitle>}
        </>}
      >
        <DialogContent style={{padding:0}}>
            <Swipeable style={{height:"calc(100%)"}} onSwipedRight={()=>{
              this.close();
            }}>
              {this.state.code && isArray(this.state.code) &&
               <div>
                 {this.state.code.map((item,index)=>{
                  return <Typography component={"div"} fullWidth size="large" key={index.toString()} style={{padding:12,fontSize:18,borderTop:"1px solid silver",cursor:"pointer",fontWeight:450}} onClick={()=>{
                    this.pick(item)
                  }}>{item.label||item}</Typography>
                 })}
               </div>
              }
              {!!this.state.InputBase && this.state.code && typeof(this.state.code)=="string" &&
              <this.state.InputBase
                {...{...this.props,...this.cust_props}}
                label={title}
                //defaultCondition={this.state.condition}
                requiredCondition={this.state.condition}
                defaultData = {this.state.defaultData}
                code={this.state.code}
                style={{padding:0,height:"calc(100% - 0px)",maxHeight}}
                bodyProps={this.cust_props.mediaQueryMatches?{style:{paddingLeft:10,paddingRight:10}}:undefined}
                contentStyle={{maxHeight:maxHeightContent}}

                handleCellClicked={row=>this.pick(row)}
                ref={ref=>this._list = ref}
                showViewTabsOnGrid ={false}
                idApp = {this.idApp}
                extraActions={()=>extraButtons}
                // Ô tìm nhanh: dùng ô MẶC ĐỊNH của InputBase (OTimNhanh — cùng kiểu DataListManager, gọi
                // this._list.search y như this.search cũ). Trên điện thoại ô này nằm ở thanh dưới đáy.

              />}
            </Swipeable>
            
        </DialogContent>
      </Dialog>
    );
  }
}
ObjectPicker.propTypes={
  fullScreen:PropTypes.bool,
  fullWidth:PropTypes.bool,
  hideTableHeader:PropTypes.bool,
  hideHeader:PropTypes.bool,
  print:PropTypes.bool,
  readOnly:PropTypes.bool,
  disabled:PropTypes.bool,

  disableBackdropClick:PropTypes.bool,
  disableEscapeKeyDown:PropTypes.bool,
  required:PropTypes.bool,

  formSize:PropTypes.oneOf(["sm","md","lg"])
}
export default  ObjectPicker;
